<template>
  <div
    v-if="categoryTag && categoryTag.name"
    :class="'tag-category-wrapper cat-'+stringToClass(categoryTag.name)"
    :id="'result-'+stringToClass(categoryTag.name)"
    :category-key="categoryTag.key"
  >
    <label>{{categoryName}}</label>

    <app-mention-tag
        v-for="(tag, key) in clonedMentions"
        :key="key"
        :organization="organization"
        :parentContainerId="parentContainerId+'-'+stringToClass(categoryTag.name)"
        :tag="tag"
        :relationTag="getRelationTag(tag)"
        :activeOrganization="activeOrganization"
        :isActive="isActive"
        :keysPressed="keysPressed"
        @deleteMentionTag="callDeleteMentionTag"
        @deleteRelationMentionTag="$emit('deleteRelationMentionTag', $event)"
        @updateMentionSentiment="$emit('updateMentionSentiment', $event)"
        @recordAction="$emit('recordAction', $event)"
        @showRelationTagMenu="$emit('showRelationTagMenu', $event)"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from 'lodash';

  import MentionTag from './mention_tag';

  import editor from '../../helpers/editor';
  import { TAG_CATEGORY } from '../../config/const';

  export default {
    props:{
      categoryKey: {
        type: [Number, String],
        required: true
      },
      organization: {
        type: Object,
        required: false,
        default: () => {
          return {};
        }
      },
      mentions: Array,
      parentContainerId: String,
      activeOrganization: String,
      keysPressed: {
        type: Array,
        required: true
      },
      isActive: {
        type: Boolean,
        default: true
      }
    },
    components: {
      'app-mention-tag': MentionTag
    },
    computed: {
      categoryTag () {
        if(this.categoryKey === TAG_CATEGORY.SOURCES) {
          return { key: TAG_CATEGORY.SOURCES, name: 'Sources' };
        }
        else {
          return this.clonedMentions?.[0]?.tag_category || {};
        }
      },
      categoryName () {
        let name = this.categoryTag && this.categoryTag.name;
        if (this.categoryTag && this.categoryTag.hasOwnProperty('active') && !this.categoryTag.active) {
          name = name + " (Inactive)";
        }
        return name;
      },
      clonedMentions () {
        return _.cloneDeep(this.mentions);
      }
    },
    methods: {
      callDeleteMentionTag({ tag, organization }) {
        this.$emit('deleteMentionTag', { tag, organization });
      },
      stringToClass(string) {
        return editor.stringToClass(string);
      },
      deleteMentionTag(tag) {
        if(!this.isActive) return
        this.$emit('deleteMentionTag', tag);
      },
      getRelationTag(tag) {
        return _.cloneDeep(tag.relation_tag);
      }
    }
  }
</script>